import React, { useEffect, useRef, useState } from 'react';
import { Waves, Heart, Scissors } from 'lucide-react';

const Services = () => {
  const [visibleCards, setVisibleCards] = useState([]);
  const [activeCard, setActiveCard] = useState(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index);
            setTimeout(() => {
              setVisibleCards((prev) => [...new Set([...prev, index])]);
            }, index * 100);
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = sectionRef.current?.querySelectorAll('[data-index]');
    cards?.forEach((card) => observer.observe(card));

    return () => {
      cards?.forEach((card) => observer.unobserve(card));
    };
  }, []);

  const handleCardClick = (index) => {
    setActiveCard(activeCard === index ? null : index);
  };

  const services = [
    {
      title: 'Tauleinen',
      description:
        'Meine spritzigen und farbenfrohen Tauleinen sind aus hochwertigem PPM-Seil gefertigt. Liebevoll und durchdacht werden Farben und Materialien zusammengestellt und mit Sorgfalt und Herzblut gefertigt. Wasserspiele sind mit diesen witterunsbeständigen und schwimmfähigen Tauleinen ein nasses Vergnügen.',
      icon: Waves
    },
    {
      title: 'Halsbänder',
      description:
        'Für jedes Leinenwerk sind passende Halsbänder ein Muss. Wie bei den Tauleinen und dem gedrehten Tauwerk setzen wir hier ebenfalls auf höchste Qualität und sehen Leinen nicht nur als praktisches Werkzeug , sondern vielmehr als ein trendiges und modisches Accessoires für Hund und Herrchen.',
      icon: Heart
    },
    {
      title: 'gedrehtes Tauwerk',
      description:
        'Meine harmonischen und handgefertigten Leinen werden aus reinem Baumwollseil liebevoll gespleisßt. Sie liegen fest in der Hand und haben eine feste Textur. Die achtsam aufeinander abgestimmten Farben und die angenehme Haptik machen den Sommerspaziergang zu einer reinen Freude',
      icon: Scissors
    }
  ];

  return (
    <section
      id='services'
      className='py-32 px-8 bg-[#fafafa] min-h-screen flex items-center max-md:py-20 max-md:px-6'
      ref={sectionRef}
    >
      <div className='max-w-[1400px] mx-auto w-full'>
        <div className='text-center mb-16'>
          <h2 className='font-display text-[3.5rem] font-bold text-zinc-900 tracking-tighter leading-tight mb-4 max-md:text-[2.75rem] max-md:tracking-tight'>
            Spei<span className='text-crimson'>se</span>karte
          </h2>
          <p className='font-sans text-[1.05rem] text-zinc-500 font-normal tracking-tight max-w-[700px] mx-auto leading-[1.7] max-md:text-base'>
            Was Uns ausmacht_Hundediesunddas mit Lust auf Farbfieber_vom
            Feinsten_einfach anders_aber alles andere als einfach_mit
            Schnickschnack und auch ohne_Anschauen_Ausflippen
          </p>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mt-12 max-md:gap-8'>
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <div
                key={index}
                onClick={() => handleCardClick(index)}
                className={`group bg-white p-10 px-8 border border-zinc-200 rounded-xl relative overflow-hidden transition-all duration-600 ease-[cubic-bezier(0.16,1,0.3,1)] cursor-pointer hover:border-crimson hover:shadow-[0_10px_40px_rgba(220,38,38,0.15)] hover:-translate-y-1 hover:scale-[1.03] ${
                  activeCard === index
                    ? 'border-crimson shadow-[0_10px_40px_rgba(220,38,38,0.15)] -translate-y-1 scale-[1.03]'
                    : ''
                } ${
                  visibleCards.includes(index)
                    ? 'opacity-100 translate-y-0'
                    : 'opacity-0 translate-y-[30px]'
                }`}
                data-index={index}
              >
                <div
                  className={`mb-6 inline-flex items-center justify-center text-crimson transition-transform duration-400 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-110 group-hover:rotate-[5deg] ${
                    activeCard === index ? 'scale-110 rotate-[5deg]' : ''
                  }`}
                >
                  <IconComponent size={64} strokeWidth={1.5} />
                </div>
                <h3 className='font-sans text-[1.4rem] text-zinc-900 mb-4 font-bold tracking-tight'>
                  {service.title}
                </h3>
                <p className='font-sans text-[0.95rem] text-zinc-500 font-normal leading-[1.7] tracking-tight'>
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
